import 'react-app-polyfill/ie11';
import { createRoot } from 'react-dom/client';

import './shared/styles/index.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
